import { combineReducers } from 'redux';
//import gs from './googleSession/gsReducer';
import taskDist from './tasks/taskReducer';
import topnav from '../redux/topnav/reducer';
//import twofaAuth from '../redux/twofaAuth/reducer'
import { reducer as form } from 'redux-form'
import auth from './auth/reducer'

export default combineReducers({auth,taskDist,topnav,form});


// WEBPACK FOOTER //
// ./src/redux/reducer.js